export const PROGRESS_TYPES = {
  WEIGHTS: "WEIGHTS",
  STEPS: "STEPS",
  CALORIES: "CALORIES",
};

export const PROGRESS_TYPE_NAMES = {
  WEIGHTS: {
    plural: "weights",
    singular: "weight",
  },
  STEPS: {
    plural: "steps",
    singular: "steps",
  },
  CALORIES: {
    plural: "foods",
    singular: "food",
  },
};
